import React, { useReducer } from 'react';
import { RouterProvider } from 'react-router-dom';
import router from '../router';
import { AnimatePresence } from 'framer-motion';
import {
	AnimationContext,
	AnimationDispatchContext,
} from '../contexts/PageContext';
import { PageAnimation, Action } from '../types/types';

const GuidedHelp: React.FC = () => {
	const initialAnimation: PageAnimation = {
		direction: 1,
	};

	const animationReducer = (
		animation: PageAnimation,
		action: Action & PageAnimation,
	) => {
		switch ( action.type ) {
			case 'directionChanged': {
				return { direction: action.direction };
			}
			default: {
				throw Error( 'Unknown action: ' + action.type );
			}
		}
	};

	const [ animation, dispatch ] = useReducer( animationReducer, initialAnimation );

	return (
		<div className="c-guided-help">
			<AnimatePresence>
				<AnimationContext.Provider value={animation}>
					<AnimationDispatchContext.Provider value={dispatch}>
						<RouterProvider router={router} />
					</AnimationDispatchContext.Provider>
				</AnimationContext.Provider>
			</AnimatePresence>
		</div>
	);
};

export default GuidedHelp;
